import React, { useState } from "react"
import firebase from "firebase/app"

import { getFunctions, httpsCallable } from "firebase/functions"

const UserList = () => {
  const [adminUsers, setAdminUsers] = useState([])
  const [becarioUsers, setBecarioUsers] = useState([])

  const functions = getFunctions()

  const fetchAdminUsers = async () => {
    try {
      const listAdminUsersCallable = httpsCallable(functions, "listAdminUsers")
      const result = await listAdminUsersCallable()
      setAdminUsers(result.data)
    } catch (error) {
      console.error("Error fetching admin users:", error)
    }
  }

  const fetchBecarioUsers = async () => {
    try {
      const listBecarioUsersCallable = httpsCallable(
        functions,
        "listBecarioUsers"
      )
      const result = await listBecarioUsersCallable()
      setBecarioUsers(result.data)
    } catch (error) {
      console.error("Error fetching admin users:", error)
    }
  }

  return (
    <div>
      <h2>Admin Users:</h2>
      <button onClick={fetchAdminUsers}>Fetch Admin Users</button>
      <ul>
        {adminUsers.map((user) => (
          <li key={user.uid}>{user.email}</li>
        ))}
      </ul>

      <h2>Becario Users:</h2>
      <button onClick={fetchBecarioUsers}>Fetch Becario Users</button>
      <ul>
        {becarioUsers.map((user) => (
          <li key={user.uid}>{user.email}</li>
        ))}
      </ul>
    </div>
  )
}

export default UserList
